import { makeStyles } from "@material-ui/core/styles";

const styles = makeStyles(theme => ({
  logo: {
    display: "flex",
    flexDirection: "column",
  },
  officeLogo: {
    width: "120px",
    height: "120px",
    objectFit: "contain",
    display: "block"
  },
  divider: {
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1),
    borderBottom: "1px solid " + theme.palette.divider,
  },
  underLine: {
    textDecoration: "underline",
    textDecorationThickness: "2px"
  },
}));
export default styles;
